module.exports = __webpack_public_path__ + "img/赛道飞车1.1be8bed8.png";